/**
 * Desktop session refresh — called on every base startup.
 *
 * POST http://127.0.0.1:50505/agent-api/desktop/session
 * with the current auth token → get a fresh 30-day token back.
 */

const SESSION_ENDPOINT = '/agent-api/desktop/session'

interface SessionRefreshResult {
  token: string
  refreshed: boolean
  expires_in: number
}

/**
 * Try to refresh/extend the user session on startup.
 * Returns the new token if successful, null if the session is expired.
 */
export async function refreshDesktopSession(currentToken: string): Promise<string | null> {
  try {
    const apiPort = import.meta.env.NEXT_PUBLIC_DESKTOP_API_URL
      ? new URL(import.meta.env.NEXT_PUBLIC_DESKTOP_API_URL).port
      : '50505'
    const resp = await fetch(`http://127.0.0.1:${apiPort}${SESSION_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Authorization: `BearerA ${currentToken}`,
        'Content-Type': 'application/json',
      },
    })

    if (!resp.ok) return null

    const data: SessionRefreshResult = await resp.json()
    if (data.token) {
      console.log(
        `[Session] ${data.refreshed ? 'Refreshed' : 'Converted'} desktop session (` +
        `${Math.round(data.expires_in / 86400)}d)`
      )
      return data.token
    }
    return null
  } catch (e) {
    console.warn('[Session] Refresh failed:', e)
    return null
  }
}
